// extracted by mini-css-extract-plugin
export default {"tableHeadCellDark":"ArchiveProjects_tableHeadCellDark__GmB6l","tableHeadCellLight":"ArchiveProjects_tableHeadCellLight__lMS-U","tableDataCell":"ArchiveProjects_tableDataCell__nEaDS"};